import { createSlice } from "@reduxjs/toolkit";

const notifications = createSlice({
    name: "notifications",
    initialState: {
        newNotifications: [],
        newNotificationsLoaded: false,
        oldNotifications: [],
        oldNotificationsLoaded: false,
    },
    reducers: {
        getNewNotifications(state, _action) {
            return { ...state, newNotificationsLoaded: false }
        },
        setNewNotifications(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                newNotifications: requestData[1],
                count: requestData[0],
                newNotificationsLoaded: true,
            }
        },
        getOldNotifications(state, _action) {
            return { ...state, oldNotificationsLoaded: false }
        },
        setOldNotifications(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                oldNotifications: requestData[1],
                oldNotificationsCount: requestData[0],
                oldNotificationsLoaded: true,
            }
        },
    },
});

export const {
    getNewNotifications,
    setNewNotifications,
    getOldNotifications,
    setOldNotifications,
} = notifications.actions;

export default notifications.reducer;
